import { render, staticRenderFns } from "./LocationMappingView.vue?vue&type=template&id=3da5a3da"
import script from "./LocationMappingView.vue?vue&type=script&lang=js"
export * from "./LocationMappingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports